import React from 'react';
import { C } from 'shared/helpers';
import PropTypes from 'prop-types';

import Styles from './Warning.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';

export default function Warning({ message, abort, act, open, setOpen, icon }) {
  const { Warning, Open } = Styles;
  return (
    <div className={C(Warning, [open, Open])}>
      <div>
        <h1>
          <FontAwesomeIcon size={'3x'} icon={icon || faBan} />
        </h1>
        <h4>{message}</h4>
        <div>
          {abort && (
            <button
              onClick={
                typeof abort === 'function' ? abort : () => setOpen(false)
              }
            >
              Cancelar
            </button>
          )}
          {act && <button onClick={act}>OK</button>}
        </div>
      </div>
    </div>
  );
}

Warning.defaultProps = {
  abort: true,
  act: null,
  setOpen: () => {},
  icon: null,
};

Warning.propTypes = {
  message: PropTypes.string.isRequired,
  abort: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  act: PropTypes.func,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func,
  icon: PropTypes.any,
};
